import { createSelector } from 'reselect';

const getEventState = (state) => state.event;

export const getEvents = createSelector([getEventState], (event) => event.events);
export const getPublishedEvents = createSelector([getEventState], (event) => event.events.filter((event) => event.isPublished));
export const getEventById = ({ eventId }) =>
  createSelector([getEventState], (event) => event.events.find((event) => event._id === eventId));
